import React from 'react';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { brandColours, maxBreakpointQuery, standardColours } from '../styles';
import { Container } from './ui';
import Search from './Search';
import { buildUrl } from '../utils';

const StyledBlogFilters = styled.section`
  padding: 25px 0;
  background-color: ${standardColours.white};
  border-bottom: solid 1px ${standardColours.lighterGrey};
`;

const StyledInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;

  ${maxBreakpointQuery.smedium`
    flex-direction: column;
  `}
`;

const StyledCategories = styled.div`
  display: flex;
  gap: 15px;

  ${maxBreakpointQuery.tsmall`
    flex-direction: column; 
  `}

  ${maxBreakpointQuery.smedium`
    width: 100%;
  `}
`;

const StyledLabel = styled.label`
  position: relative;

  ${maxBreakpointQuery.smedium`
    width: 100%;
  `}

  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid ${standardColours.transparent};
    border-right: 5px solid ${standardColours.transparent};
    border-top: 5px solid ${standardColours.black};
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }
`;

const StyledSelect = styled.select`
  padding: 18px;
  padding-right: 38px;
  border: solid 1px ${brandColours.secondary};
  border-radius: 30px;
  width: 100%;
  flex-shrink: 0;
  position: relative;
  appearance: none;
`;

const StyledOption = styled.option``;

const BlogFilters = ({
  currentPage,
  searchItems,
  setSearchResults,
  location,
}) => {
  const { datoCmsBlogListing } = useStaticQuery(graphql`
    query BlogFiltersQuery {
      datoCmsBlogListing {
        initialCategoryLists: categoryLists {
          singularName
          pluralName
          categories {
            title
            ...LinkFragment
          }
        }
        ...LinkFragment
      }
    }
  `);

  const { initialCategoryLists } = datoCmsBlogListing;

  const categoryLists = initialCategoryLists.map(initialCategoryList => {
    const allCategoriesItem = {
      title: `All ${initialCategoryList.pluralName}`,
      ...datoCmsBlogListing,
    };

    return {
      ...initialCategoryList,
      categories: [allCategoriesItem, ...initialCategoryList.categories],
    };
  });

  return (
    <StyledBlogFilters>
      <Container>
        <StyledInner>
          <StyledCategories>
            {categoryLists.map(({ singularName, categories }, id) => (
              <StyledLabel key={id}>
                <StyledSelect
                  name="blog-categories"
                  required
                  onChange={e => navigate(e.target.value)}
                >
                  <StyledOption value={`By ${singularName}`} selected disabled>
                    {`By ${singularName}`}
                  </StyledOption>
                  {categories.map((category, id) => (
                    <StyledOption
                      key={id}
                      value={buildUrl(category.slug, category)}
                      selected={
                        buildUrl(category.slug, category) ===
                        buildUrl(currentPage.slug, currentPage)
                      }
                    >
                      {category.title}
                    </StyledOption>
                  ))}
                </StyledSelect>
              </StyledLabel>
            ))}
          </StyledCategories>
          <Search
            items={searchItems}
            setResults={setSearchResults}
            location={location}
          />
        </StyledInner>
      </Container>
    </StyledBlogFilters>
  );
};

export default BlogFilters;
